import React from "react";
import { ClassificationIcon, TreeView } from "@sscs/ui";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import { FILE_BROWSER_ROUTES } from "../../../constants";
import { isMaliciousOrSuspicious } from "../../../utils";
import styles from "./tabs.module.scss";
const sectionLabel = (text, classification) => isMaliciousOrSuspicious(classification) ? (React.createElement("span", { className: styles["node-label"] },
    React.createElement(ClassificationIcon, { classification: classification }),
    text)) : (text);
const SectionRail = ({ counters, fileClassification, worstDependencyClassification, }) => {
    var _a;
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const activeSection = (_a = pathname.split("/").pop()) !== null && _a !== void 0 ? _a : null;
    const nodes = [
        {
            id: FILE_BROWSER_ROUTES.INFO_ROUTE,
            label: sectionLabel("File info", fileClassification),
            count: "→",
        },
        {
            id: FILE_BROWSER_ROUTES.ISSUES_ROUTE,
            label: "Issues",
            count: counters === null || counters === void 0 ? void 0 : counters.issues,
        },
        {
            id: FILE_BROWSER_ROUTES.VULNERABILITIES_ROUTE,
            label: "Vulnerabilities",
            count: counters === null || counters === void 0 ? void 0 : counters.vulnerabilities,
        },
        {
            id: FILE_BROWSER_ROUTES.DEPENDENCIES_ROUTE,
            label: sectionLabel("Dependencies", worstDependencyClassification),
            count: counters === null || counters === void 0 ? void 0 : counters.dependencies,
        },
        {
            id: FILE_BROWSER_ROUTES.SECRETS_ROUTE,
            label: "Secrets",
            count: counters === null || counters === void 0 ? void 0 : counters.secrets,
        },
        {
            id: FILE_BROWSER_ROUTES.BEHAVIOR_ROUTE,
            label: "Behaviors",
            count: counters === null || counters === void 0 ? void 0 : counters.behavior,
        },
        {
            id: FILE_BROWSER_ROUTES.EVENTS_ROUTE,
            label: "Events",
            count: counters === null || counters === void 0 ? void 0 : counters.actions,
        },
        {
            id: FILE_BROWSER_ROUTES.SIGNATURES_ROUTE,
            label: "Signatures",
            count: counters === null || counters === void 0 ? void 0 : counters.signatures,
        },
        {
            id: FILE_BROWSER_ROUTES.NETWORKING_ROUTE,
            label: "Networking",
            count: counters === null || counters === void 0 ? void 0 : counters.networking,
        },
    ];
    const handleChange = (selected) => {
        navigate({ pathname: selected, search: searchParams.toString() });
    };
    return (React.createElement(TreeView, { "aria-label": "File sections", nodes: nodes, selected: activeSection, onChange: handleChange }));
};
export default SectionRail;
//# sourceMappingURL=SectionRail.js.map